export const companyNewsRecords = [
  {
    slug: "company-smart-factory-200000sqm-operation",
    category: "company",
    title: {
      "zh-CN": "智能升级，产能蓄力｜江苏宏邦智能化新厂区正式启动建设",
      "en-US": "Smart Manufacturing Upgrade and Capacity Expansion | Jiangsu Hongbang Smart New Factory Project Officially Launched"
    },
    excerpt: {
      "zh-CN": "江苏宏邦启动智能化新厂区建设，配置自动化生产线与数字化平台，进一步提升研发、智造与交付能力。",
      "en-US": "Jiangsu Hongbang has launched its smart new factory project to enhance intelligent manufacturing, R&D strength and large-scale delivery capacity."
    },
    date: "2026-03-15",
    views: 186,
    sourceName: { "zh-CN": "江苏宏邦变压器有限公司", "en-US": "Jiangsu Hongbang Transformer Co., Ltd." },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "为响应国家新型电力系统建设发展号召，进一步提升智能制造水平、产品研发实力与规模化订单交付能力，江苏宏邦变压器有限公司智能化新厂区项目已正式启动建设。",
        "新厂区规划布局现代化生产车间、研发检测中心及配套设施，将配置自动化生产线、智能检测设备与数字化管理运营平台。项目建成后，将全面优化生产流程、提升产品品质与交付效率，持续增强企业市场供货能力与综合服务实力，为深耕全球配电设备市场、服务海内外工程项目发展筑牢坚实根基。"
      ],
      "en-US": [
        "In response to the national initiative for the development of a new-type power system, Jiangsu Hongbang Transformer Co., Ltd. has officially launched the construction of its smart manufacturing new factory project.",
        "The project aims to further enhance intelligent manufacturing capability, product R&D strength, and large-scale order delivery capacity.",
        "The new factory is planned with a modern layout including advanced production workshops, R&D and testing centers, and supporting facilities.",
        "It will be equipped with automated production lines, intelligent testing systems, and a digital operation and management platform.",
        "Upon completion, the project will comprehensively optimize production processes, improve product quality and delivery efficiency, and significantly strengthen the company's supply capability and integrated service strength.",
        "This initiative will further support Jiangsu Hongbang in deepening its presence in the global power distribution equipment market, while reinforcing its capability to serve overseas engineering projects and international infrastructure development."
      ]
    }
  },
  {
    slug: "company-eight-high-efficiency-transformer-upgrades",
    category: "company",
    title: {
      "zh-CN": "聚焦能效升级｜江苏宏邦完成8款高能效低损耗变压器迭代升级",
      "en-US": "Focus on Energy Efficiency Upgrades | Jiangsu Hongbang Completes Iterative Upgrade of 8 High-Efficiency Low-Loss Transformer Models"
    },
    excerpt: {
      "zh-CN": "江苏宏邦完成8款变压器产品的高能效、低损耗迭代升级，多款产品损耗指标优于国家一级能效标准。",
      "en-US": "Jiangsu Hongbang completed high-efficiency and low-loss upgrades for eight transformer models, with several products exceeding Grade I energy efficiency requirements."
    },
    date: "2025-12-20",
    views: 172,
    sourceName: { "zh-CN": "江苏宏邦变压器有限公司", "en-US": "Jiangsu Hongbang Transformer Co., Ltd." },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "为助力“双碳”目标落地，江苏宏邦持续深耕节能配电技术研发，2025年成功完成8款变压器产品的高能效、低损耗迭代升级。",
        "本次升级聚焦铁心优化、线圈结构改进与工艺革新，多款产品损耗指标优于国家一级能效标准，可有效降低用户用电成本，为工业、新能源及配网项目提供更高效、更环保的电力设备解决方案。"
      ],
      "en-US": [
        "In support of China's dual carbon goals, Jiangsu Hongbang Transformer Co., Ltd. continues to deepen its R&D in energy-saving distribution technologies.",
        "In 2025, the company successfully completed the iterative upgrade of 8 transformer models, focusing on high energy efficiency and low-loss performance optimization.",
        "The upgrade emphasizes improvements in core material design, winding structure optimization, and manufacturing process innovation.",
        "Several upgraded models have achieved loss performance superior to Grade I energy efficiency standards, effectively reducing end-user energy consumption costs.",
        "These advanced products provide more efficient and environmentally friendly power equipment solutions for industrial applications, renewable energy systems, and distribution network projects."
      ]
    }
  },
  {
    slug: "company-2024-sales-over-3-billion",
    category: "company",
    title: {
      "zh-CN": "扩能增效，业绩突破｜江苏宏邦2024年销售业绩超30亿元",
      "en-US": "Capacity Expansion and Performance Breakthrough | Jiangsu Hongbang Achieves RMB 3+ Billion Sales in 2024"
    },
    excerpt: {
      "zh-CN": "2024年，江苏宏邦持续扩大生产规模，全年销售业绩突破30亿元，市场竞争力与行业影响力持续提升。",
      "en-US": "Jiangsu Hongbang expanded production capacity in 2024 and achieved annual sales exceeding RMB 3 billion."
    },
    date: "2024-11-08",
    views: 158,
    sourceName: { "zh-CN": "江苏宏邦变压器有限公司", "en-US": "Jiangsu Hongbang Transformer Co., Ltd." },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "2024年，江苏宏邦持续扩大生产规模，工厂面积提升至5.8万平方米，新建两座标准化生产车间，进一步释放产能、优化交付效率。",
        "凭借稳定的产品品质与优质的客户服务，公司全年销售业绩突破30亿元，同比实现大幅增长，市场竞争力与行业影响力持续提升。"
      ],
      "en-US": [
        "In 2024, Jiangsu Hongbang Transformer Co., Ltd. continued to expand its production capacity, with its manufacturing facility increasing to 58,000 square meters.",
        "The company has newly built two standardized production workshops, further enhancing production capacity and improving delivery efficiency.",
        "Supported by stable product quality and strong customer service capabilities, the company achieved annual sales exceeding RMB 3 billion in 2024, representing significant year-on-year growth.",
        "This performance marks a continuous improvement in market competitiveness and industry influence, reflecting the company's sustained progress in the power transformer sector."
      ]
    }
  },
  {
    slug: "company-full-process-quality-control-system",
    category: "company",
    title: {
      "zh-CN": "质量为本，标准先行｜江苏宏邦建立全流程质量管控体系",
      "en-US": "Quality as the Foundation, Standards as the Guideline | Jiangsu Hongbang Establishes Full-Process Quality Control System"
    },
    excerpt: {
      "zh-CN": "江苏宏邦建立覆盖来料检验、生产过程监控、出厂试验等全环节的严格质量管控体系。",
      "en-US": "Jiangsu Hongbang has established a full-process quality control system covering incoming inspection, production monitoring and final factory testing."
    },
    date: "2023-09-15",
    views: 143,
    sourceName: { "zh-CN": "江苏宏邦变压器有限公司", "en-US": "Jiangsu Hongbang Transformer Co., Ltd." },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "为筑牢产品品质防线，江苏宏邦于2023年正式建立全流程严格质量管控体系，覆盖来料检验、生产过程监控、出厂试验等全环节。",
        "公司产品顺利通过多项行业专业检测，关键性能指标均达到国家及行业标准要求，以严苛品控为客户提供可靠的电力设备保障。"
      ],
      "en-US": [
        "To further strengthen product quality assurance, Jiangsu Hongbang Transformer Co., Ltd. formally established a comprehensive full-process quality control system in 2023.",
        "The system covers all critical stages, including incoming material inspection, in-process production monitoring, and final factory testing, ensuring strict quality supervision throughout the entire manufacturing cycle.",
        "All products have successfully passed multiple industry-standard testing and certification procedures, with key performance indicators fully meeting national and industry requirements.",
        "Through rigorous quality control practices, the company is committed to delivering reliable and high-performance power equipment solutions to global customers."
      ]
    }
  },
  {
    slug: "company-jiangsu-hongbang-established",
    category: "company",
    title: {
      "zh-CN": "扬帆起航，立足实业｜江苏宏邦变压器有限公司正式成立",
      "en-US": "Set Sail on a New Journey | Jiangsu Hongbang Transformer Co., Ltd. Officially Established"
    },
    excerpt: {
      "zh-CN": "2022年，江苏宏邦变压器有限公司正式成立，落户江苏徐州并建成标准化现代化生产基地。",
      "en-US": "Jiangsu Hongbang Transformer Co., Ltd. was officially established in Xuzhou, Jiangsu, marking a solid step into the transformer industry."
    },
    date: "2022-06-28",
    views: 132,
    sourceName: { "zh-CN": "江苏宏邦变压器有限公司", "en-US": "Jiangsu Hongbang Transformer Co., Ltd." },
    sourceUrl: "",
    content: {
      "zh-CN": [
        "2022年，江苏宏邦变压器有限公司正式成立，落户江苏徐州并建成标准化现代化生产基地。",
        "公司专注于输配电设备研发、制造与销售，以“品质立业、服务致远”为理念，迈出了深耕变压器行业的坚实一步。"
      ],
      "en-US": [
        "In 2022, Jiangsu Hongbang Transformer Co., Ltd. was officially established, with its headquarters and standardized modern manufacturing base located in Xuzhou, Jiangsu Province, China.",
        "The company is dedicated to the research, development, manufacturing, and sales of power transmission and distribution equipment, adhering to the philosophy of \"Quality Builds Foundation, Service Drives Long-Term Growth.\"",
        "With a strong focus on the transformer industry, Jiangsu Hongbang has taken a solid step forward in building its long-term presence in the global power equipment sector."
      ]
    }
  }
];
